module.exports = __webpack_public_path__ + "static/media/undraw_finance_0bdk.7b3ea357.png";